import React from 'react';
import { CheckCircle2, Users, Heart, Building2, Award } from 'lucide-react';
import { trustIndicators } from '../mock';

const TrustStrip = () => {
  const iconMap = {
    CheckCircle2: CheckCircle2,
    Users: Users,
    Heart: Heart,
    Building2: Building2,
    Award: Award
  };

  return (
    <section className="bg-white py-8 sm:py-12 border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-4 sm:gap-6">
          {trustIndicators.map((item, index) => {
            const Icon = iconMap[item.icon];
            return (
              <div 
                key={index} 
                className="flex flex-col items-center text-center group cursor-pointer"
              >
                <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-full bg-gradient-to-br from-[#0077BE]/10 to-[#00B4D8]/10 flex items-center justify-center mb-2 sm:mb-3 group-hover:scale-110 transition-transform duration-300">
                  <Icon className="w-6 h-6 sm:w-7 sm:h-7 text-[#0077BE]" />
                </div>
                <p className="text-xs sm:text-sm font-semibold text-[#0B0F14]">{item.text}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default TrustStrip;
